import React from 'react';
import { Helmet } from 'react-helmet';
import { Grid, Loader, Segment } from 'semantic-ui-react';

// Workspaces
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';

// Global Components
// @ts-ignore
import asyncComponent from 'components/AsyncComponent';
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
// @ts-ignore
import ErrorGate from 'components/ErrorGate';
import LoadingGate from 'components/LoadingGate';
// @ts-ignore
import Online from 'components/Online';
import PageTitleAndFilters from 'components/PageTitleAndFilters';
// @ts-ignore
import PageWrapper from 'components/PageWrapper';

// Components
// @ts-ignore
import ReportsHarvestInspectionsCardGroup from '../../components/ReportsHarvestInspectionsCardGroup';
// @ts-ignore
import ReportsHarvestInspectionsRequest from '../../components/ReportsHarvestInspectionsRequest';
// @ts-ignore
import ReportsHarvestInspectionsTable from '../../components/ReportsHarvestInspectionsTable';
// @ts-ignore
import HarvestInspectionsExportButton from './components/HarvestInspectionsExportButton';
// @ts-ignore
import ReportsHarvestInspectionsPeopleRequest from './components/ReportsHarvestInspectionsPeopleRequest';
// @ts-ignore
import ReportsHarvestInspectionsPeopleTable from './components/ReportsHarvestInspectionsPeopleTable';

const AsyncReportsHarvestInspectionsDefectsGraph = asyncComponent(() =>
    // @ts-ignore
    import('./components/ReportsHarvestInspectionsDefectsGraph')
);

// Environment
const { REACT_APP_PROJECT_NAME } = process.env;

const QualityReport = (): React.ReactElement => (
    <ErrorBoundary
        namespace="QualityReport"
        FallbackComponent={<ErrorBoundaryAlert />}
    >
        <Helmet>
            <title>
                Quality Report -
                {' '}
                {REACT_APP_PROJECT_NAME}
            </title>
        </Helmet>
        <Online>
            <ReportsHarvestInspectionsRequest />
            <ReportsHarvestInspectionsPeopleRequest />
        </Online>
        <PageTitleAndFilters
            title="Quality Report"
            Button={<HarvestInspectionsExportButton />}
            currentEntity
            currentSeason
            pickType
            variety
            varietyMultiple
            entity
        />
        <PageWrapper top={0} bottom={50}>
            <LoadingGate
                namespace="REPORTS_HARVEST_INSPECTIONS_LOAD"
                LoadingComponent={
                    <PageWrapper>
                        <Loader active inline="centered" />
                    </PageWrapper>
                }
            >
                <ErrorGate namespace="REPORTS_HARVEST_INSPECTIONS_LOAD">
                    <Grid>
                        <Grid.Row reversed="computer">
                            <Grid.Column
                                tablet={16}
                                computer={2}
                                stretched
                                style={{ marginBottom: 10 }}
                            >
                                <ReportsHarvestInspectionsCardGroup jobType="INSPECTION" />
                            </Grid.Column>
                            <Grid.Column
                                tablet={16}
                                computer={14}
                                style={{ marginBottom: 10 }}
                            >
                                <ReportsHarvestInspectionsTable
                                    jobType="INSPECTION"
                                    defaultCount={5}
                                    defaultSort="overallDefectPercentage_descending"
                                />
                            </Grid.Column>
                            <Grid.Column
                                tablet={16}
                                computer={8}
                                stretched
                                style={{ marginBottom: 10 }}
                            >
                                <AsyncReportsHarvestInspectionsDefectsGraph />
                            </Grid.Column>
                            <Grid.Column
                                tablet={16}
                                computer={8}
                                stretched
                                style={{ marginBottom: 10 }}
                            >
                                <LoadingGate
                                    namespace="REPORTS_HARVEST_INSPECTIONS_PEOPLE_LOAD"
                                    LoadingComponent={
                                        <Segment>
                                            <Loader active inline="centered" />
                                        </Segment>
                                    }
                                >
                                    <div>
                                        <ErrorGate namespace="REPORTS_HARVEST_INSPECTIONS_PEOPLE_LOAD">
                                            <ReportsHarvestInspectionsPeopleTable />
                                        </ErrorGate>
                                    </div>
                                </LoadingGate>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </ErrorGate>
            </LoadingGate>
        </PageWrapper>
    </ErrorBoundary>
);

export default QualityReport;
